import React, { useState, useEffect, useRef } from "react";
import { CSSTransitionGroup } from "react-transition-group"; // ES6
import "../css/arv.css";
import "../fonts/Walt.ttf";
import Footer from "../components/Footer";
import GoToTop from "../GoToTop";
import Navigation from "../views/Navigation";
import WineStaticPage from "../views/WineStaticPage";
import OurWines from "../views/OurWines";
import WhereToFind from "../views/WhereToFind";
import PrivateEvents from "../views/PrivateEvents";
import TheEnoteca from "../views/TheEnoteca";
import WhatsHappening from "../views/WhatsHappening";
import Winemakers from "../views/Winemakers.js";
import DinnerVineyards from "../views/DinnerVineyards.js";
import LiveVineyardStage from "../views/LiveVineyardStage.js";
import ToursTastings from "../views/ToursTastings.js";
import Press from "../views/Press.js";
import Menu from "../views/Menu.js";
import WineStories from "../views/WineStories";
import MeetJulesScott from "../views/MeetJulesScott";
import WineStoryPage from "../views/WineStoryPage";
import Sustainability from "../views/Sustainability";
import GivingBack from "../views/GivingBack";
import FAQ from "../views/FAQ";
import Home from "../views/Home";
import ContactOverlay from "../views/ContactOverlay";
import SecondaryMenu from "../views/SecondaryMenu";
import WinePlaylists from "../views/WinePlaylists";
import NotFoundPage from "../views/NotFoundPage";
import Cowtown from "../views/Cowtown";
import GoodKarmaCafe from "../views/GoodKarmaCafe";
import UnderConstruction from "../views/UnderConstruction";
import FullPageLoader from "../components/FullPageLoader";
import Benvenuti from "../views/Benvenuti";
import Wave1 from "../images/waves/cream-wave-1.svg";
import Wave2 from "../images/waves/cream-wave-2.svg";
import Wave3 from "../images/waves/cream-wave-3.svg";
import Wave4 from "../images/waves/cream-wave-4.svg";
import Wave5 from "../images/waves/cream-wave-5.svg";
import { Switch, Route, useLocation } from "react-router-dom";
import axios from "axios";
import getStrapiUrl, { getStrapiApiToken } from "../utils/strapiUrl";
import { cachedGet } from "../utils/strapiCache";

// Strapi API configuration
const STRAPI_URL = getStrapiUrl() + "/api";
const STRAPI_API_TOKEN = getStrapiApiToken();
// Log token status in development
if (process.env.NODE_ENV === "development") {
  console.log("Strapi API Configuration:", {
    url: STRAPI_URL,
    tokenPresent: !!STRAPI_API_TOKEN,
    tokenLength: STRAPI_API_TOKEN?.length,
  });
}

const strapiClient = axios.create({
  baseURL: `${STRAPI_URL}`,
  headers: {
    ...(STRAPI_API_TOKEN && { Authorization: `Bearer ${STRAPI_API_TOKEN}` }),
    "Content-Type": "application/json",
  },
});

// Add response interceptor to log 401 errors
strapiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("401 Unauthorized - Check your Strapi API token:", {
        url: error.config?.url,
        tokenPresent: !!STRAPI_API_TOKEN,
        tokenLength: STRAPI_API_TOKEN?.length,
        baseURL: STRAPI_URL,
      });
    }
    return Promise.reject(error);
  }
);
const CreateRouter = () => {
  const location = useLocation();
  const previousLocationRef = useRef(location);
  const [privateEvents, setPrivateEvents] = useState(null);
  const [winemakers, setWinemakers] = useState(false);
  const [menuItems, setMenuItems] = useState(null);
  const [winePages, setWinePages] = useState(null);
  const [wineStories, setWineStories] = useState(null);
  const [meetJulesAndScott, setMeetJulesAndScott] = useState(null);
  const [cowtown, setCowtown] = useState(null);
  const [benvenuti, setBenvenuti] = useState(null);
  const [whatsHappening, setWhatsHappening] = useState(null);
  const [musicalArtists, setMusicalArtists] = useState(null);
  const [toursAndTastings, setToursAndTastings] = useState(null);
  const [dinnerInTheVineyards, setDinnerInTheVineyards] = useState(null);
  const [winePlaylists, setWinePlaylists] = useState(null);
  const [showContact, setShowContact] = useState(false);
  const [hours, setHours] = useState(null);
  const [cellarWines, setCellarWines] = useState(null);
  const [faqQuestions, setFaqQuestions] = useState(null);
  const [pressItems, setPressItems] = useState(null);
  const [sustainability, setSustainability] = useState(null);
  const [givingBack, setGivingBack] = useState(null);

  useEffect(() => {
    cachedGet(
      strapiClient,
      "/wine-stories?sort=publish_date:desc&populate=*&pagination[pageSize]=100"
    )
      .then((response) => {
        const stories = [...(response.data.data || [])].sort((a, b) => {
          const aDate = a.publish_date || a.createdAt || "";
          const bDate = b.publish_date || b.createdAt || "";
          return new Date(bDate) - new Date(aDate);
        });
        setWineStories(stories);
      })
      .catch((error) => {
        console.error("Error fetching wine stories:", error);
        if (error.response) {
          console.error("Response status:", error.response.status);
          console.error("Response data:", error.response.data);
        }
      });
    cachedGet(strapiClient, "/private-events?populate=*")
      .then((response) => {
        setPrivateEvents(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching private events:", error);
      });
    cachedGet(strapiClient, "/wine-pages?populate=*")
      .then((response) => {
        const wines = response.data.data || [];
        setWinePages(wines);
        setWinePlaylists(
          wines.reduce((acc, x) => {
            acc[x.wine_name] = x.playlist;
            return acc;
          }, {})
        );
      })
      .catch((error) => {
        console.error("Error fetching wines:", error);
      });
    cachedGet(strapiClient, "/menu-items?populate=*&pagination[pageSize]=100")
      .then((response) => {
        setMenuItems(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching menu items:", error);
        if (error.response) {
          console.error("Response status:", error.response.status);
          console.error("Response data:", error.response.data);
        }
      });

    cachedGet(
      strapiClient,
      "/meet-jules-and-scott?populate[mainImage]=true&populate[wine_stories][populate]=*"
    )
      .then((response) => {
        setMeetJulesAndScott(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching meet jules and scott:", error);
      });
    cachedGet(strapiClient, "/winemakers?populate=*")
      .then((response) => {
        setWinemakers(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching meet the winemakers:", error);
      });

    cachedGet(strapiClient, "/faq-questions?sort=createdAt:desc&populate=*")
      .then((response) => {
        setFaqQuestions(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching faq questions:", error);
      });
    cachedGet(strapiClient, "/cowtown?populate[card][populate]=*")
      .then((response) => {
        setCowtown(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching cowtown:", error);
      });
    cachedGet(
      strapiClient,
      "/benvenuti?populate[image]=true&populate[wine_pages][populate]=*"
    )
      .then((response) => {
        setBenvenuti(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching benvenuti:", error);
      });
    cachedGet(
      strapiClient,
      "/whats-happening?populate[wine_story][populate]=*&populate[events][populate]=*"
    )
      .then((response) => {
        setWhatsHappening(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching whats happening:", error);
      });
    cachedGet(strapiClient, "/musical-artists?populate=*")
      .then((response) => {
        setMusicalArtists(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching musical artists:", error);
      });
    cachedGet(strapiClient, "/hours?populate=*")
      .then((response) => {
        setHours(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching hours:", error);
        if (error.response) {
          console.error("Response status:", error.response.status);
          console.error("Response data:", error.response.data);
        }
      });
    cachedGet(strapiClient, "/cellar-wines?populate=*")
      .then((response) => {
        setCellarWines(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching cellar wines:", error);
        if (error.response) {
          console.error("Response status:", error.response.status);
          console.error("Response data:", error.response.data);
        }
      });
    cachedGet(strapiClient, "/dinners-in-the-vineyard?populate=*")
      .then((response) => {
        setDinnerInTheVineyards(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching dinner in the vineyards:", error);
      });
    cachedGet(strapiClient, "/tours-and-tasting?populate=*")
      .then((response) => {
        setToursAndTastings(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching tours and tastings:", error);
      });
    cachedGet(strapiClient, "/press-items?populate=*")
      .then((response) => {
        setPressItems(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching press items:", error);
      });
    cachedGet(strapiClient, "/sustainability?populate=*")
      .then((response) => {
        setSustainability(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching sustainability:", error);
      });
    cachedGet(
      strapiClient,
      "/giving-back-community?populate[partnership][populate]=*"
    )
      .then((response) => {
        setGivingBack(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching giving back:", error);
      });
  }, []);

  useEffect(() => {
    if (!(location.state && location.state.modal)) {
      previousLocationRef.current = location;
    }
  }, [location]);

  const toggleContactOverlay = () => {
    setShowContact((prev) => !prev);
    if (document.querySelector("body").classList.length) {
      document.getElementById("body").classList.remove("scroll-lock");
    } else {
      document.getElementById("body").classList.add("scroll-lock");
    }
  };

  const noFooterUrls = ["nutrition-ingredients"];

  const getWaveImage = () => {
    const waveImages = [Wave1, Wave2, Wave3, Wave4, Wave5];
    const rando = Math.floor(Math.random() * waveImages.length);
    return waveImages[rando];
  };

  return (
    <>
      <GoToTop />
      <div className="app">
        <img src={getWaveImage()} className="wave" alt="" />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route
            exact
            path="/where-to-find-our-wines"
            component={WhereToFind}
          />
          <Route exact path="/menu">
            <Menu
              hours={hours}
              cellarWines={cellarWines}
              menuItems={menuItems}
              title="Food and Wine Menu"
            />
          </Route>
          <Route exact path="/menu-local">
            <Menu
              hours={hours}
              cellarWines={cellarWines}
              menuItems={menuItems}
              title="Local Food and Wine Menu"
            />
          </Route>
          <Route path="/menu/:type">
            <SecondaryMenu items={menuItems} />
          </Route>
          <Route exact path="/private-events">
            <PrivateEvents info={privateEvents} />
          </Route>
          <Route exact path="/the-enoteca" component={TheEnoteca} />
          <Route exact path="/meet-jules-and-scott">
            <MeetJulesScott info={meetJulesAndScott} />
          </Route>
          <Route exact path="/cowtown">
            <Cowtown info={cowtown} />
          </Route>
          <Route exact path="/benvenuti">
            <Benvenuti info={benvenuti} />
          </Route>
          <Route exact path="/our-wines">
            <OurWines info={winePages} />
          </Route>
          {winePages &&
            winePages.map((x) => {
              const hyphenWineName = x.wine_name
                .split(" ")
                .join("-")
                .toLowerCase();
              const wine = x.wine_name;
              return (
                <Route exact path={"/" + hyphenWineName} key={wine}>
                  <WineStaticPage wine={x} />
                </Route>
              );
            })}
          <Route exact path="/tours-and-tastings">
            <ToursTastings info={toursAndTastings} />
          </Route>
          <Route exact path="/dinner-in-the-vineyards">
            <DinnerVineyards info={dinnerInTheVineyards} />
          </Route>
          <Route exact path="/live-at-the-vineyard-stage">
            <LiveVineyardStage info={musicalArtists} />
          </Route>
          <Route path="/goodkarmacafephilly" component={GoodKarmaCafe} />
          <Route exact path="/the-winemakers">
            <Winemakers info={winemakers} />
          </Route>
          <Route path="/under-construction" component={UnderConstruction} />
          <Route exact path="/whats-happening">
            <WhatsHappening info={whatsHappening} music={musicalArtists} />
          </Route>
          <Route exact path="/faq">
            <FAQ
              data={faqQuestions}
              toggleContactOverlay={toggleContactOverlay}
            />
          </Route>
          <Route exact path="/in-the-press">
            <Press info={pressItems} />
          </Route>
          <Route exact path="/sustainability">
            <Sustainability info={sustainability} />
          </Route>
          <Route exact path="/giving-back">
            <GivingBack info={givingBack} />
          </Route>
          <Route exact path="/wine-stories">
            <WineStories stories={wineStories} />
          </Route>
          <Route exact path="/wine-playlists">
            <WinePlaylists playlists={winePlaylists} />
          </Route>
          {wineStories &&
            wineStories.map((x, i, array) => {
              const baseTitle = x.Title || x.title || "";
              const slug = (baseTitle || "").split(" ").join("-").toLowerCase();
              const title = x.unique_url || slug;
              const next = array[i - 1];
              const previous = array[i + 1];
              return (
                <Route path={"/" + title} key={title || i}>
                  <WineStoryPage
                    story={x}
                    nextPost={next ? next : null}
                    previousPost={previous ? previous : null}
                  />
                </Route>
              );
            })}
          {(!winePages || !wineStories) && (
            <Route render={() => <FullPageLoader />} />
          )}
          <Route path="*" component={NotFoundPage} />
        </Switch>
        {noFooterUrls.filter((x) => location.pathname.includes(x)).length >
        0 ? null : (
          <Navigation toggleContactOverlay={toggleContactOverlay} />
        )}
        {showContact ? (
          <CSSTransitionGroup
            transitionName="contact"
            transitionAppear={true}
            transitionAppearTimeout={2000}
            transitionEnter={true}
            transitionLeave={true}
            transitionLeaveTimeout={5000}
          >
            <ContactOverlay
              toggleContactOverlay={toggleContactOverlay}
              hours={hours}
            />
          </CSSTransitionGroup>
        ) : null}
      </div>
      {noFooterUrls.filter((x) => location.pathname.includes(x)).length >
      0 ? null : (
        <Footer />
      )}
    </>
  );
};
export default CreateRouter;
